import {Rules as VariableRules} from "./variable";
import {Rules as TextRules} from "../html/text";
import {DeserializedRules} from "../../slate/Transformation";

const Elements: DeserializedRules<string> = {
    elements: {
        "block": {
            isVoid: () => false,
            tagType: () => 'block',
            match: (n) => n.type === 'block',
            deserialize(el, next) {
                return undefined;
            },
            serialize(node, next) {
                return next(node.children);
            },
            render: ({node}) => {
                if (node.element.type === 'block') {
                    return node.children;
                }
            }
        },
        ...VariableRules,
        /*"other": {
            isVoid: () => false,
            tagType: () => 'inline',
            match: () => true,
            deserialize(el, next) {
                return {text: el.textContent};
            },
            serialize(node, next) {
                return node.text;
            },
            render: ({node}) => {
                //console.log(node);
                return node.children;
            }
        }*/
    },
    leaves: {
        "text": {
            isVoid: () => false,
            tagType: () => 'inline',
            match: (element) => element.hasOwnProperty('text'),
            deserialize(el, next) {
                return {
                    text: el
                };
            },
            serialize(node, leaf, next) {
                return leaf;
            },
            render: ({leaf}) => {
                //console.log(node);
                return leaf;
            }
        },
    }
}

export default Elements;